import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import { Link } from "react-router-dom";
import ABI from './ABI.json'; // Adjust the path to where your ABI file is stored
import { useSDK } from "@metamask/sdk-react";

const ImageGenerator = () => {
	const [userMessage, setUserMessage] = useState('');
    	const [fat, setFat] = useState('');
    	const [fileName, setFileName] = useState(''); // Default file name
    	const [walletAddress, setWalletAddress] = useState(null);
    	const [connected, setConnected] = useState(null);
	const [loadingMessage, setLoadingMessage] = useState(''); // New state for loading message
	const [loadingText, setLoadingText] = useState('Loading');
	const [mintStatus, setMintStatus] = useState(''); // New state for minting status message
	const [errorMessage, setErrorMessage] = useState(''); // New state for error message
	const [tokenID, setTokenID] = useState('');
	const { sdk, provider } = useSDK();

	const predefinedString = "1 girl, wearing battle gear, plain background";

	const Address ="0x7c62FcD5cdB713B94050F1F91A62D113d0aada33";

    	const isValidUrl = (string) => {
        	try {
			new URL(string);
			return true;
		} catch (_) {
			return false;  
		}
	};

	const connectWallet = async () => {
		try {
		  const accounts = await sdk?.connect();
		  const networkId = await provider?.request({ method: 'net_version' });
	
		  if (networkId === '1111' && accounts && accounts.length > 0) {
			const address = accounts[0];
			setConnected(true);
			setWalletAddress(address);
		  } else {
			try {
			  await provider?.request({
				method: 'wallet_addEthereumChain',
				params: [{
				  chainId: '0x457', // Chain ID in hexadecimal (1111 in decimal)
				  chainName: 'WEMIX3.0', // Name of the custom network
				  nativeCurrency: {
					name: 'WEMIX', // Native currency name
					symbol: 'WEMIX', // Native currency symbol
					decimals: 18
				  },
				  rpcUrls: ['https://api.wemix.com/'], // RPC URL of the custom network
				  blockExplorerUrls: ['https://www.wemixscan.com'] // Block explorer URL of the custom network
				}]
			  });
	
			  // Reconnect to get updated network ID
			  const newNetworkId = await provider?.request({ method: 'net_version' });
			  if (newNetworkId === '1111') {
				setConnected(true);
				setWalletAddress(accounts?.[0]);
			  }
			} catch (switchError) {
			  console.log('User rejected chain switch:', switchError);
			}
		  }
		} catch (error) {
		  console.error('Error connecting to MetaMask:', error);
		}
	  };

	const generateImage = async (userMessage, walletAddress) => {
		const finalString = `${userMessage}, ${predefinedString}`;
		console.log('Sending to backend:', { finalString, walletAddress }); // Debugging log
		setFat('')
		setErrorMessage("");
		try {
		  const response = await fetch('https://icecream-423008.as.r.appspot.com/generate-image', {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			},
			body: JSON.stringify({ prompt: userMessage, walletAddress }),
		  });
	  
		  if (!response.ok) {
			throw new Error('Network response was not ok');
		  }
	  
		  const data = await response.json();
		  console.log('Backend response:', data); // Log the response from the backend
		  setFat(data.images);
		  setLoadingMessage(''); // Hide loading message

		} catch (error) {
			setLoadingMessage(''); // Hide loading message	
		}
	  };
	
	  const handleSubmit = (e) => {
		  e.preventDefault();
		  setLoadingMessage("IceCream AI is working on it...should take around 30 seconds! Vn_n");
		  generateImage(userMessage, walletAddress);
	  };

	  useEffect(() => {
		  const loadingInterval = setInterval(() => {
			  setLoadingText(prev => {
				  if (prev === 'Loading...')
					  return 'Loading';
				  return prev + '.';
			  });
		  }, 500); // Update every 500ms
		  return () => clearInterval(loadingInterval); // Cleanup interval on unmount
	  }, []);
	
	const checkNameOwnership = async (name) => {
		  try {
			  const web3 = new Web3(provider);
			  const game = new web3.eth.Contract(ABI, Address);
			  const owner = await game.methods.getOwner(name).call();
			  if (owner !== '0x0000000000000000000000000000000000000000') {
				  return true; // Name is taken
			  }
			  return false; // Name is available
		  } catch (error) {
			  console.error('Error checking name ownership:', error);
			  return false; // Treat any error as the name being available to prevent blocking the user
		  }
	  };
	
	const handleUploadAndMint = async () => {
		if (!fat) {
			console.error("No image to upload");
			return;
		}
		
		const isNameTaken = await checkNameOwnership(fileName);
		if (isNameTaken) {
			setMintStatus("Sorry, name already taken!");
			return;
		}
		
		setMintStatus('Almost there...plx wait'); // Show minting loading message
		
		try {
			const web3 = new Web3(provider);
			const game = new web3.eth.Contract(ABI, Address);
			const txParams = {
				from: walletAddress,
				maxPriorityFeePerGas: web3.utils.toWei('100', 'gwei'),
				maxFeePerGas: web3.utils.toWei('101', 'gwei')
			};
			await game.methods.mint(walletAddress, fileName, '').send(txParams)
				.on("error", (err) => {
					console.log(err);
				})
				.then(async (receipt) => {
					const uploadResponse = await fetch('https://icecream-423008.as.r.appspot.com/api/upload', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							fileName: fileName,
							walletAddress: walletAddress, // Send the walletAddress to the backend
							}),
					});
					if (!uploadResponse.ok) {
						throw new Error(`HTTP error! status: ${uploadResponse.status}`);
					}
					const data = await uploadResponse.json();
					const token = await game.methods.getTokenId(fileName).call();
					setTokenID(token);
					setMintStatus('Minted. uWu'); // Show success message
				});
		} catch (error) {
			console.error('Error uploading image:', error);
			setMintStatus('Something went wrong. T_T'); // Show failure message
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	};
	
	const handleReset = (e) => {
		e.preventDefault();
		setFat('');
		setMintStatus('');
	};
	
	return (
		<div>
	{!connected && (
		<div>
		<h3><b>Connect Metamask to begin</b></h3>
		<button className="nav-button" onClick={connectWallet}>uWu 🦊</button>
		</div>
		)}

{connected && !loadingMessage && !fat && (
	<form onSubmit={handleSubmit}>
	<h3><b>Describe your AI GF's Appearance</b></h3>
	<br></br>
	<textarea
	value={userMessage}
		onChange={(e) => setUserMessage(e.target.value)}
			onKeyDown={(e) => handleKeyDown(e)}
placeholder="Describe her..."
	rows={5} // Set the number of visible rows
cols={50} // Set the number of visible columns
	className="styled-textarea"
		/>
		<br></br>
		<br></br>
		<button className="nav-button" type="submit">WAGMI</button>
		</form>
		)}

{connected && loadingMessage &&(
	<div className="mob">
	<p className="mobile">{loadingMessage}</p>
	<h3>{loadingText}</h3>
	<h3>{errorMessage}</h3>
	</div>
	)}

{fat && isValidUrl(fat) ? (
	<div className="bro">
	<h3><b>Your AI GF</b></h3>
	<br></br>
	<div>
			<img src={fat} alt="Generated Image" className="half-screen-width" />
			<br></br>
			<div>
			<h3><p>Bring her on-chain!</p></h3>
			<p>it's free.</p>
            <input type="text" className="styled-textarea" placeholder="Enter your GF's name" value={fileName} onChange={(e) => setFileName(e.target.value)}/>
			<br></br>
			<br></br>
            <button className="nav-button" onClick={handleUploadAndMint}>LFG</button>
			<br></br>
			<b><p>{mintStatus}</p></b>
			{!mintStatus && (
			<button onClick={handleReset}className="nav-button">(or try again)</button>)}
			{mintStatus === 'Minted. uWu' && (
				<div>
						<Link to="/chat"><button className="nav-button">visit her!</button></Link>
						<br></br>
						<a href={`https://wemixscan.com/token/${Address}?a=${tokenID}`} target="_blank" rel="noopener noreferrer">
						<button className="nav-button">View on Etherscan</button>
						</a>
						</div>)}
			  {mintStatus === 'Something went wrong. T_T' && (
              <button onClick={handleReset}className="nav-button">(or try again)</button>)}
                  </div>
            </div>
        </div>
        ) : (
			fat === '' && errorMessage ? <p>{errorMessage}</p> : null
        )}

        </div>
        );};

export default ImageGenerator;
